define([],
	function() { 
        var splitTrafficIntoGroups = function(options, callback){
            var groupName = options.groupName,
                dataPointType = options.dataPointType,
                numberOfGroups = +options.numberOfGroups,
                persistance = options.persistance,
                saveFunc = (dataPointType == "a")?uDash.saveAttribute:uDash.saveMeta,
                groupValue = null,
                storage = null,
                triggerId = options.triggerId || "",
                storageKey = storageKey = "uResponses." + (triggerId?triggerId + ".":"") + groupName;

            if(persistance == "user"){
                storage = localStorage;
            }
            else if(persistance == "session"){
                storage = sessionStorage;
            }

            if(storage){
                groupValue = storage.getItem(storageKey);
            }
            
            if(!groupValue){
                groupValue = Math.floor(Math.random() * numberOfGroups) + 1;
                if(storage){
                    storage.setItem(storageKey, groupValue);
                }
            }

            saveFunc(groupName, groupValue);
              
            callback(null);
        };
		return splitTrafficIntoGroups;
	}
);



//////////////////
// WEBPACK FOOTER
// ./responses/data-collection/splitTrafficIntoGroups/splitTrafficIntoGroups.js
// module id = 38
// module chunks = 13